import React from 'react'
import GoalTag from './goal_tag'

const GoalTagList = ({ goalTags }) => {
    return (
        <div className="goal-tag-list">
            <div className="goal-tag-all">
                {goalTags.map((goal, i) => {
                    return (
                        <div key={i} className='goal-tag-container'>
                            {parseFloat(goal.currentAmount) >= parseFloat(goal.goalAmount) && <i className='fa fa-check check-icon'/>}
                            <GoalTag key={i} goal={goal} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default GoalTagList



// WEBPACK FOOTER //
// ./src/components/goal_tag_list.jsx